<template>
  <div class="profile-panel-no-items" v-if="poolsList.total === 0">
    <h3 class="profile-panel-no-items-title">No Items Found</h3>
    <p class="profile-panel-no-items-text">
      {{ profilePanelNoItemsText }}
    </p>
  </div>
  <div class="profile-panel-body-wrapper" v-else>
    <div class="profile-panel-filter-search">
      <div class="profile-panel-search">
        <app-input
          v-model="searchString"
          placeholder="Search by name, pool, tag or cause"
          inputClass="app-modal-input"
        />
      </div>
      <div class="profile-panel-filter">
        <div class="profile-panel-filter-wrapper">
          <div
            class="profile-panel-filter-overlay"
            @click="toggle(filtersFlag.showFilters)"
          ></div>
          <app-input
            placeholder="Filter and sort"
            inputClass="app-modal-input"
            inputIconLeftClass="filter-icon"
            :inputIconRightClass="{
              'chevron-icon': true,
              active: filtersFlag.showFilters.value,
            }"
            :inputStyle="filterStyle"
            disabled
          />
        </div>
        <teleport to="body">
          <div
            class="filtering-options-overlay"
            @click="toggle(filtersFlag.showFilters)"
            v-if="filtersFlag.showFilters.value"
          ></div>
        </teleport>
        <div class="filtering-options" v-if="filtersFlag.showFilters.value">
          <h3 class="filtering-options-heading">Sort by</h3>
          <p
            class="filtering-option"
            @click="toggleFilter('filterHighestFloorPrice')"
          >
            Highest floor price
          </p>
          <p
            class="filtering-option"
            @click="toggleFilter('filterLowestFloorPrice')"
          >
            Lowestfloor price
          </p>
          <h3 class="filtering-options-heading">Filter</h3>
          <div class="filtering-checkbox">
            <p class="filtering-option">Slots available</p>
            <div
              class="checkbox"
              :class="{ checked: filters.filterSlotsAvailable }"
              @click="toggleFilter('filterSlotsAvailable')"
            ></div>
          </div>
          <div class="filtering-checkbox">
            <p class="filtering-option">No slots available</p>
            <div
              class="checkbox"
              :class="{ checked: filters.filterSlotsNotAvailable }"
              @click="toggleFilter('filterSlotsNotAvailable')"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="profile-panel-body-content">
      <div v-for="(card, index) in poolsList.data" :key="index">
        <app-card :token="card"></app-card>
      </div>
    </div>
  </div>
</template>

<script>
import useProfilePanels from "@/composables/useProfilePanels";
import { useStore } from "vuex";
// import AppInput from "@/elements/AppInput";
// import AppCard from "@/components/AppCard";
export default {
  components: {
    // AppInput,
    // AppCard,
  },
  setup() {
    const {
      poolsList,
      searchString,
      filtersFlag,
      filtersStyle,
      toggle,
      filters,
      profilePanelNoItemsText,
    } = useProfilePanels(useStore());
    return {
      poolsList,
      searchString,
      filtersFlag,
      filtersStyle,
      toggle,
      filters,
      profilePanelNoItemsText,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/profilePanels.scss"></style>
